module.exports = Modernizr;